import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class GeneralHelperService {
  private changeSomeBusinessProfile = new BehaviorSubject<{ categoryId: number, businessId: number | null}>({categoryId: 0, businessId: null});

  constructor() {
  }

  getChangeSomeBusinessProfile(): Observable<{ categoryId: number, businessId: number | null}> {
    return this.changeSomeBusinessProfile.asObservable();
  }

  setChangeSomeBusinessProfile(value: { categoryId: number, businessId: number | null}): void {
    this.changeSomeBusinessProfile.next(value);
  }
}
